export default __webpack_public_path__ + "static/media/BC.d51d782d.png";